import type { ReactNode } from 'react'

import { Label } from '@/components'
import { cn } from '@/utils'

interface FilterInputWrapperProps {
  label: string
  children: ReactNode
  gap?: 2 | 3
  className?: string
}

export function FilterInputWrapper({
  label,
  children,
  gap = 2,
  className,
}: FilterInputWrapperProps) {
  return (
    <div className={cn(`grid gap-${gap}`, className)}>
      <Label>{label}</Label>
      {children}
    </div>
  )
}
